export default "__VITE_ASSET__CsfrTER8__"